import { css } from "glamor";
import React from "react";
import { spacing } from "./theme";

const hintStyles = css({
  marginTop: spacing.xxs,
  lineHeight: 1.4,
  fontSize: 12
});

const extraSpace = css({
  marginTop: spacing.xs,
});

export default function Hint(props) {
  // eslint-disable-next-line no-unused-vars
  const { children, spaced, italic, className, ...rest } = props;
  return (
    <div className={css(hintStyles, className, spaced && extraSpace)} {...rest}>
      {children}
    </div>
  );
}
